import { render, staticRenderFns } from "./ProjectVersionCreateBanner.vue?vue&type=template&id=03dc0aa4&lang=pug&"
import script from "./ProjectVersionCreateBanner.vue?vue&type=script&lang=js&"
export * from "./ProjectVersionCreateBanner.vue?vue&type=script&lang=js&"
import style0 from "./ProjectVersionCreateBanner.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports